import { Box, Button } from '@mui/material';

type ModalFooterProps = {
  onCancel: () => void;
  onBack?: () => void;
  onPrimaryAction: () => void;
  isPrimaryActionDisabled?: boolean;
  isPrimaryActionLoading?: boolean;
  label: {
    back: string;
    cancel: string;
    primaryCta: string;
  };
};

const ModalFooter = ({
  onCancel,
  onBack,
  onPrimaryAction,
  isPrimaryActionDisabled = true,
  isPrimaryActionLoading = false,
  label,
}: ModalFooterProps) => {
  return (
    <Box
      sx={{
        borderTop: '1px solid var(--divider, rgba(0, 0, 0, 0.12))',
        padding: 3,
        flexShrink: 0,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
        }}
      >
        <Button
          variant='outlined'
          onClick={onCancel}
          type='button'
        >
          {label.cancel}
        </Button>

        <Box sx={{ display: 'flex', gap: 1 }}>
          <>
            {onBack && (
              <Button
                variant='outlined'
                onClick={onBack}
                type='button'
              >
                {label.back}
              </Button>
            )}

            <Button
              onClick={onPrimaryAction}
              variant='contained'
              disabled={isPrimaryActionDisabled}
              loading={isPrimaryActionLoading}
              type='button'
            >
              {label.primaryCta}
            </Button>
          </>
        </Box>
      </Box>
    </Box>
  );
};

export default ModalFooter;
